var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g(_vm._b({staticClass:"material-symbols-rounded app-icon",class:[_vm.utilityClasses, { 'app-icon--filled': _vm.filled }],style:(_vm.iconStyle),attrs:{"aria-hidden":_vm.label ? null : 'true',"aria-label":_vm.label || null,"role":_vm.label ? 'img' : null}},'span',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm.resolvedName))])
}
var staticRenderFns = []

export { render, staticRenderFns }